var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-plant", {
                  attrs: { type: "search", name: "plantCd" },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-select", {
                  attrs: {
                    type: "search",
                    comboItems: _vm.col1Items,
                    itemText: "codeName",
                    itemValue: "code",
                    label: "연/원료 구분",
                    name: "col1",
                  },
                  model: {
                    value: _vm.searchParam.col1,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "col1", $$v)
                    },
                    expression: "searchParam.col1",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-select", {
                  attrs: {
                    type: "search",
                    comboItems: _vm.col2Items,
                    itemText: "codeName",
                    itemValue: "code",
                    label: "연료구분",
                    name: "col2",
                  },
                  model: {
                    value: _vm.searchParam.col2,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "col2", $$v)
                    },
                    expression: "searchParam.col2",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
          [
            _c(
              "c-table",
              {
                ref: "table",
                attrs: {
                  title: "사용 연료/원료",
                  tableId: "processManual",
                  columns: _vm.grid.columns,
                  gridHeight: _vm.grid.height,
                  data: _vm.grid.data,
                  columnSetting: false,
                  isFullScreen: false,
                  usePaging: false,
                  expandAll: true,
                  selection: "multiple",
                  rowKey: "col0",
                },
                on: { linkClick: _vm.linkClick },
              },
              [
                _c(
                  "template",
                  { slot: "table-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _c("c-btn", {
                          attrs: { label: "LBLADD", icon: "add" },
                        }),
                        _c("c-btn", {
                          attrs: { label: "LBLREMOVE", icon: "remove" },
                        }),
                        _c("c-btn", {
                          attrs: { label: "LBLSAVE", icon: "save" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }